// Central registry of build-hashed static assets.
//
// WHY: importing an asset here (instead of referencing a fixed /public path) routes it through
// webpack's asset pipeline, which emits `static/media/<name>.<contenthash>.<ext>`. The URL changes
// IFF the bytes change, so cache invalidation is automatic and permanent — never a manual `?v=`
// bump. See memory/hero_cache_trap_2026-06.md for the incident that motivated this.
//
// NOT here (must keep fixed /public paths — do not hash):
//   • /opticswap-logo.png and /hero/email/*.jpg — embedded in transactional emails by
//     backend/email_service.py as ABSOLUTE URLs; old emails reference them forever.
//   • /geo/*.json — runtime-fetched map DATA (not display assets), behind the business flag.
//   • /favicon.ico — served at the conventional fixed root path.

import logo from "./brand/opticswap-logo.png";
import logoDarkPng from "./brand/opticswap-logo-dark.png";
import logoDarkWebp from "./brand/opticswap-logo-dark.webp";

import topoA from "./topo/topo-a.svg";
import topoB from "./topo/topo-b.svg";

import hunterLg from "./hero/hunter-bear-lg.webp";
import hunterSm from "./hero/hunter-bear-sm.webp";
import hunterFull from "./hero/hunter-bear.webp";
import coastLg from "./hero/coastline-lg.webp";
import coastSm from "./hero/coastline-sm.webp";
import coastFull from "./hero/coastline.png";
import riflesLg from "./hero/rifles-flag-lg.webp";
import riflesSm from "./hero/rifles-flag-sm.webp";
import riflesFull from "./hero/rifles-flag.png";
import heliLg from "./hero/helicopter-lg.webp";
import heliSm from "./hero/helicopter-sm.webp";
import heliFull from "./hero/helicopter.png";

export const LOGO = logo;
export const LOGO_DARK = logoDarkPng;
export const LOGO_DARK_WEBP = logoDarkWebp;

export const TOPO_A = topoA;
export const TOPO_B = topoB;

// Per-base responsive hero sources: { sm (400w), lg (800w), full (original) }.
export const HERO = {
  "hunter-bear": { sm: hunterSm, lg: hunterLg, full: hunterFull },
  "coastline": { sm: coastSm, lg: coastLg, full: coastFull },
  "rifles-flag": { sm: riflesSm, lg: riflesLg, full: riflesFull },
  "helicopter": { sm: heliSm, lg: heliLg, full: heliFull },
};

// The 2x2 auth/gallery grid (AccountEntry, Login, Register, InTheWild) — kept in one place
// so the four surfaces stay in sync.
export const AUTH_PHOTOS = [
  HERO["hunter-bear"].full,
  HERO["coastline"].full,
  HERO["rifles-flag"].full,
  HERO["helicopter"].full,
];
